<template>
  <div>
    <LoadViewModal />
    <UnlockLoadModal />
    <ConsolidateLoadsModal />
    <BarcodeOrderViewModal />
  </div>
</template>
<script>
import LoadViewModal from "@/components/widgets/Modals/LoadViewModal";
import UnlockLoadModal from "@/components/widgets/Modals/UnlockLoadModal";
import ConsolidateLoadsModal from "@/components/widgets/Modals/ConsolidateLoadsModal"
import BarcodeOrderViewModal from "@/components/widgets/Modals/BarcodeOrderViewModal";
export default {
  name: "LoadsActions",
  components: {
    LoadViewModal,
    UnlockLoadModal,
    ConsolidateLoadsModal,
    BarcodeOrderViewModal
  }
};
</script>